<template>
    <span>
        {{ value | datetime }}
    </span>
</template>

<script>
import Column from '@mixins/Column';

export default {
    mixins: [ Column ]
}
</script>
